<template>
    <div class="video-pdf">
        <div class="mt-2 d-flex justify-content-between flex-wrap align-items-center">
            <template v-if="activeSeatNum">
                <CBadge color="success" @click="collapseDownloads = !collapseDownloads" class="mb-2 text-left badge-share">
                    Downloads, Share, Brief FAQ&nbsp;<img src="../assets/img/sort-down.svg" alt="">
                </CBadge>
                <div class="mb-2">
                    <a :class="'mt-1 mr-1 '+ (vPR['reportPdf' + activeSeatNum] ? '' : 'linkDisabled')"
                       style="color:#3c4b64"
                       :href="vPR['reportPdf' + activeSeatNum] ? fileUrl(vPR['reportPdf' + activeSeatNum].id) : '#'"
                       target="_blank">PDF</a>
                    <div style="width:15px" class="ml-3 mt-1"
                         v-if="!vPR['reportPdf' + activeSeatNum] && processingInProgress">
                        <Spinner style="width:20px; height:20px"/>
                    </div>
                </div>
            </template>
            <div class="video-date text-md-right text-sm-left mb-2">
                <span style="padding-right:1em">Added by {{ training.owner.username }}</span>
                <span> {{ formatDateTime(training.createdAt) }} </span>
            </div>
        </div>
        <CCollapse :show="collapseDownloads" :duration="400" v-if="activeSeatNum">
            <CRow class="mt-4 mb-0">
                <CCol>
                    <CCard body-wrapper class="mb-0">
                        <CRow>
                            <CCol>
                                <CCardText class="d-flex flex-wrap">
                                    <div class="mr-3">Downloads:</div>
                                    <div class="mr-3 d-flex flex-wrap align-items-center">
                                        <a :class="(vPR['reportPcVideo' + activeSeatNum] ? '' : 'linkDisabled')"
                                           :href="vPR['reportPcVideo' + activeSeatNum] ? fileUrl(vPR['reportPcVideo' + activeSeatNum].id, true) : '#'"
                                           target="_blank" download>Video</a>
                                        <Spinner style="width:15px; height:15px" class="ml-3"
                                                 v-if="!vPR['reportPcVideo' + activeSeatNum] && processingInProgress"/>
                                        <div v-else>
                                            <CButton class="p-0" @click.prevent="doPcVideoDownload(video, activeSeatNum)">
                                                <!--suppress HtmlUnknownTag -->
                                                <CIcon name="cilDataTransferDown"/>
                                            </CButton>
                                        </div>
                                    </div>
                                    <div class="mr-3 d-flex flex-wrap align-items-center">
                                        <a :class="(vPR['reportInstaVideo' + activeSeatNum] ? '' : 'linkDisabled')"
                                           :href="vPR['reportInstaVideo' + activeSeatNum] ? fileUrl(vPR['reportInstaVideo' + activeSeatNum].id, true) : '#'"
                                           target="_blank" download>Video for Instagram</a>
                                        <Spinner style="width:15px; height:15px" class="ml-3"
                                                 v-if="!vPR['reportInstaVideo' + activeSeatNum] && processingInProgress"/>
                                        <div v-else>
                                            <CButton class="p-0" @click.prevent="doInstaVideoDownload(video, activeSeatNum)">
                                                <!--suppress HtmlUnknownTag -->
                                                <CIcon name="cilDataTransferDown"/>
                                            </CButton>
                                        </div>
                                    </div>
                                    <div class="mr-3 d-flex flex-wrap align-items-center">
                                        <a :class="(vPR['reportPdf' + activeSeatNum] ? '' : 'linkDisabled')"
                                           :href="vPR['reportPdf' + activeSeatNum] ? fileUrl(vPR['reportPdf' + activeSeatNum].id, true) : '#'"
                                           target="_blank">PDF</a>
                                        <Spinner style="width:15px; height:15px" class="ml-3"
                                                 v-if="!vPR['reportPdf' + activeSeatNum] && processingInProgress"/>
                                        <div v-else>
                                            <CButton class="p-0" @click.prevent="doPdfDownload(video, activeSeatNum)">
                                                <!--suppress HtmlUnknownTag -->
                                                <CIcon name="cilDataTransferDown"/>
                                            </CButton>
                                        </div>
                                    </div>
                                </CCardText>
                                <CCardText class="d-flex flex-wrap">
                                    <div class="mr-3">Link for sharing:</div>
                                    <div class="mr-3 d-flex flex-wrap align-items-center">
                                        <a v-if="feedType === 'training'" :href="trainingUrl">{{
                                                trainingUrl
                                            }}</a>
                                        <CLink v-else
                                               :to="{name: 'training', params: {trainingId: training.id, activeTab, trainingParams: trainingParamsArrForUrl}}">
                                            {{ trainingUrl }}
                                        </CLink>
                                    </div>
                                </CCardText>
                            </CCol>
                        </CRow>
                    </CCard>
                </CCol>
            </CRow>
            <CRow class="mb-2">
                <CCol>
                    <TrainingFaq/>
                </CCol>
            </CRow>
        </CCollapse>
    </div>
</template>

<script>
    import Spinner from "@/components/Spinner.vue";
    import moment from "moment";
    import fileUtils from "@/mixins/file-utils";
    import {getDateFormat} from '@/scripts/utils';
    import TrainingFaq from "@/components/TrainingFaq.vue";

    export default {
        components: {
            TrainingFaq,
            Spinner
        },
        props: {
            training: Object,
            activeTab: String,
            vPR: Object,
            activeSeatNum: [String, Number],
            trainingUrl: String,
            trainingParamsArrForUrl: Array,
            feedType: String,
        },
        mixins: [fileUtils],
        data() {
            return {
                collapseDownloads: false,
            }
        },
        methods: {
            doPdfDownload(video, seatNum) {
                if (video.videoProcessingResult['reportPdf' + seatNum])
                    window.open(this.fileUrl(video.videoProcessingResult['reportPdf' + seatNum].id, true), '_blank')
            },
            doPcVideoDownload(video, seatNum) {
                if (video.videoProcessingResult['reportPcVideo' + seatNum])
                    window.open(this.fileUrl(video.videoProcessingResult['reportPcVideo' + seatNum].id, true))
            },
            doInstaVideoDownload(video, seatNum) {
                if (video.videoProcessingResult['reportInstaVideo' + seatNum])
                    window.open(this.fileUrl(video.videoProcessingResult['reportInstaVideo' + seatNum].id, true))
            },
            formatDateTime(dateStr) {
                return moment.utc(dateStr).local().format(`${this.dateFormat} HH:mm`)
            },
        },
        computed: {
            video() {
                return this.training.videos[0]
            },
            processingInProgress() {
                return !this.vPR.criticalErrorFlag && !this.vPR.finishedAt
            },
            dateFormat() {
                return getDateFormat();
            }
        }
    }

</script>

<style lang="scss">
    .badge.badge-share {
        font-size: 100%;
        font-weight: 400;
        line-height: 1.5;
        cursor: pointer;
        white-space: normal;
    }
</style>